export const images = {
  retraite: {
    contact: '/retraite/contact.webp',
    hero: '/retraite/hero.webp',
  },
  cagnup: {
    cta: '/cagnup/cta.webp',
    appStore: '/cagnup/app-store.svg',
    googlePlay: '/cagnup/google-play.png',
    hero: '/cagnup/hero.webp',
  },
  social: {
    linkedin: '/social/linkedin.svg',
    instagram: '/social/instagram.svg',
    youtube: '/social/youtube.svg',
  },
  polyseme: {
    'logo-icon': '/polyseme/logo-icon.svg',
    'logo-text': '/polyseme/logo-text.svg',
    hero: '/polyseme/hero.png',
    contract: {
      blue: '/polyseme/contract-blue.png',
      black: '/polyseme/contract-black.png',
      orange: '/polyseme/contract-orange.png',
      green: '/polyseme/contract-green.png',
    },
    bento: {
      1: '/polyseme/bento-1.jpg',
      2: '/polyseme/bento-2.jpg',
      3: '/polyseme/bento-3.svg',
    },
    contact: {
      ceo: '/polyseme/antoine-millet.webp',
      cco: '/polyseme/jean-francois-bonneville.webp',
      linkedin: '/polyseme/linkedin.svg',
      email: '/polyseme/email.svg',
    },
    germen: '/polyseme/logo-germen-noir.svg',
    integrations: {
      hubspot: '/polyseme/hubspot.svg',
      informatica: '/polyseme/informatica.png',
      kapia: '/polyseme/kapia.svg',
      mailjet: '/polyseme/mailjet.svg',
      mulesoft: '/polyseme/mulesoft.svg',
      salesforce: '/polyseme/salesforce.svg',
      yousign: '/polyseme/yousign.svg',
      garance: '/polyseme/garance-small.svg',
    },
  },
  germen: {
    'logo-icon': '/germen/logo-icon.svg',
    'logo-text': '/germen/logo-germen-noir.png',
    'banner-placeholder': '/germen/banner-placeholder.svg',
    'simulator-hero': '/germen/demo-simulator.gif',
    slide1: '/germen/slide1.png',
    slide2: '/germen/slide2.png',
    slide3: '/germen/slide3.png',
    handshake: '/germen/handshake.png',
  },
  logoWhite: '/garance-logo-white.svg',
  logo: '/garance-logo.svg',
  shape: '/garance-shape.svg',
};
